// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VideoPresentations_video-presentations__3FzKh .VideoPresentations_lectures__teeU3 {
  margin-bottom: 30px;
  padding: 25px;
  border-radius: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
}
.VideoPresentations_video-presentations__3FzKh .VideoPresentations_lectures__teeU3 .VideoPresentations_section-title__yKKS\\+ {
  margin-top: 15px;
  font-size: 20px;
  font-weight: bold;
  text-transform: capitalize;
  margin-bottom: 30px;
}
.VideoPresentations_video-presentations__3FzKh .VideoPresentations_lectures__teeU3 .VideoPresentations_video-list__UQisr {
  width: 100%;
  background: white;
  height: 250px;
}
.VideoPresentations_video-presentations__3FzKh .VideoPresentations_lectures__teeU3 .VideoPresentations_video-list__UQisr .VideoPresentations_videoItem__2JsBP {
  max-width: 420px;
  min-width: 420px;
}
@media only screen and (max-width: 900px) {
  .VideoPresentations_video-presentations__3FzKh .VideoPresentations_lectures__teeU3 {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/FacultyDetail/Components/VideoPresentations/VideoPresentations.module.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;AAAJ;AAEI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,mBAAA;AAAN;AAGI;EACE,WAAA;EACA,iBAAA;EACA,aAAA;AADN;AAGM;EACE,gBAAA;EACA,gBAAA;AADR;AAII;EAxBF;IAyBI,aAAA;EADJ;AACF","sourcesContent":[".video-presentations {\n  .lectures {\n    margin-bottom: 30px;\n    padding: 25px;\n    border-radius: 10px;\n    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);\n\n    .section-title {\n      margin-top: 15px;\n      font-size: 20px;\n      font-weight: bold;\n      text-transform: capitalize;\n      margin-bottom: 30px;\n    }\n\n    .video-list {\n      width: 100%;\n      background: white;\n      height: 250px;\n\n      .videoItem {\n        max-width: 420px;\n        min-width: 420px;\n      }\n    }\n    @media only screen and (max-width: 900px) {\n      display: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"video-presentations": `VideoPresentations_video-presentations__3FzKh`,
	"lectures": `VideoPresentations_lectures__teeU3`,
	"section-title": `VideoPresentations_section-title__yKKS+`,
	"video-list": `VideoPresentations_video-list__UQisr`,
	"videoItem": `VideoPresentations_videoItem__2JsBP`
};
export default ___CSS_LOADER_EXPORT___;
